import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Header, Footer } from './components/molecules';
import DDSStatusBanner from './components/resilience/DDSStatusBanner';

const HEADER_HEIGHT = 96;
const FOOTER_HEIGHT = 88;


const Layout = ({
  children,
  showHeader = true,
  showFooter = true,
  flushTop = false,
  headerProps,
  footerProps,
}) => (
  <Box
    sx={{
      minHeight: '100vh',
      bgcolor: '#050505',
      color: 'text.primary',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {showHeader && (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          // px: { xs: 2, md: 4 },
          // pt: { xs: 2, md: 3 },
          pb: 0,
          pointerEvents: 'none',
          zIndex: (theme) => theme.zIndex.appBar,
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0) 100%)',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 'full', pointerEvents: 'auto' }}>
          <Header {...headerProps} />
        </Box>
      </Box>
    )}

    <Box
      component="main"
      sx={{
        width: '100%',
        px: 0,
        // flushTop (copilot) removes the top gap so the grid sits at the very top.
        pt: flushTop ? 0 : (showHeader ? 8 : 2), // Less top padding when no header
        // Footer is fixed; reserve its height. Copilot uses a tighter reserve that
        // matches TXLive's grid FOOTER_RESERVE so the grid fills without scrolling.
        pb: flushTop ? '56px' : (showFooter ? '80px' : 4),
        flexGrow: 1,
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'stretch',
        alignItems: 'stretch',
      }}
    >
      <DDSStatusBanner />
      {children}
    </Box>
    {headerProps?.showContinue && (
      <Box
        sx={{
          position: "fixed",
          bottom: showFooter ? 88 + 10 : 10, // footer height + 10px gap
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          pointerEvents: "none",
          zIndex: (theme) => theme.zIndex.appBar + 1,
        }}
      >
        <Box sx={{ pointerEvents: "auto" }}>
          {headerProps.continueButton}
        </Box>
      </Box>
    )}

    {showFooter && (
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >
        <Footer {...footerProps} />
      </Box>
    )}
  </Box>
);

Layout.propTypes = {
  children: PropTypes.node,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  flushTop: PropTypes.bool,
  headerProps: PropTypes.object,
  footerProps: PropTypes.object,
};

export default Layout;

